// Diagnoses why a stream URL failed to play by probing it from the browser.
// Stream hosts (e.g. Bunny) with a referer allowlist return 403 for domains
// not on the list — without this probe the player just silently shows black.
export const diagnoseStreamError = async (src?: string): Promise<string> => {
  if (!src) {
    return 'No stream URL is configured for this video.'
  }
  try {
    const resp = await fetch(src, { cache: 'no-store' })
    if (resp.status === 403) {
      return (
        `The stream host refused to serve this video to ${window.location.hostname} (HTTP 403). ` +
        'If the stream library restricts playback by domain (e.g. Bunny → Stream → Security → Allowed domains), ' +
        'add this domain to the allowed list.'
      )
    }
    if (!resp.ok) {
      return `The stream URL returned HTTP ${resp.status}. Check the URL is correct.`
    }
    return 'The stream URL is reachable but playback failed — check it points to a valid HLS playlist (.m3u8).'
  } catch {
    return 'Could not reach the stream URL (network or CORS error). Check the URL is correct and publicly accessible.'
  }
}
